import { Label } from '@components/ui/label';
import { Separator } from '@components/ui/separator';
import type * as LabelPrimitive from '@radix-ui/react-label';
import { forwardRef } from 'react';
import { cn } from '@/lib/utils';

export const ColumnElement = forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>((p, ref) => (
  <div className={cn('flex flex-col gap-1.5', p.className)} ref={ref} {...p}>
    {p.children}
  </div>
));

export const ColumnTitle = forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>
>((p, ref) => (
  <>
    <Label className={cn('font-medium text-sm', p.className)} ref={ref} {...p}>
      {p.children}
    </Label>
    <Separator />
  </>
));
